type AppToastProps = {
  message: string;
};

/** Page-level toast: top-center, does not shift layout. */
export function AppToast({ message }: AppToastProps) {
  return (
    <div
      role="status"
      className="pointer-events-none fixed top-6 left-1/2 z-[200] max-w-[min(92vw,28rem)] -translate-x-1/2 rounded-lg bg-ink/90 px-4 py-2 text-center text-sm text-white shadow-lg"
    >
      {message}
    </div>
  );
}
